<template>
  <div class="search-bar-container">
    <input
      ref="searchInputRef"
      v-model="searchTerm"
      class="search-bar-container__input outlined-input"
      placeholder="Search"
      @input="$emit('update-search-term', searchTerm)"
      @keydown="handleKeydown"
    >
    <SearchIcon
      ref="searchIconRef"
      class="search-bar-container__icon"
    />
  </div>
</template>

<script lang="ts">
import SearchIcon from '@/components/svgs/MenuIcons/SearchIcon.vue';

export default {
  components: {
    SearchIcon,
  },
  emits: [
    'update-search-term',
    'handle-keys',
  ],
  data() {
    return {
      searchTerm: '',
    };
  },
  computed: {
    searchIconHeight() {
      return getComputedStyle((this.$refs['searchIconRef'] as InstanceType<typeof SearchIcon>).$el).height ?? 0;
    },
  },
  mounted() {
    (this.$refs['searchInputRef'] as InstanceType<typeof HTMLInputElement>).focus();
  },
  methods: {
    /* Emits an event when a traversal or selection key is pressed. */
    handleKeydown(e: KeyboardEvent) {
      if (['ArrowUp', 'ArrowDown', 'Enter'].includes(e.code)) {
        e.preventDefault();
        this.$emit('handle-keys', e.code);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar-container {
  position: relative;
  background-color: white;
  border-radius: 5px;

  &__input {
    height: 100% !important;
    width: 100% !important;
    border-radius: 5px;
  }
  &__icon {
    fill: main.$midGray;
    position: absolute;
    right: 10px;
    top: calc(50% - v-bind(searchIconHeight) / 2);
  }
}
</style>
